'use client';

import React, { useState, useEffect } from 'react';
import NextTopLoader from 'nextjs-toploader';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import NProgress from 'nprogress';

// You can pass other NextTopLoader props if needed
type CustomNextTopLoaderProps = Omit<React.ComponentProps<typeof NextTopLoader>, 'showAtBottom'>;

const CustomNextTopLoader: React.FC<CustomNextTopLoaderProps> = (props) => {
  const [isMobile, setIsMobile] = useState(false);

  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  
  useEffect(() => {
    NProgress.done();
  }, [pathname, router, searchParams]);

  useEffect(() => {
    const mobileCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('mobile='))
      ?.split('=')[1] || null;
    setIsMobile(mobileCookie === 'true');
  }, []);

  return <NextTopLoader {...props} showAtBottom={!isMobile} />;
};

export default CustomNextTopLoader;
